import * as React from 'react';
import { useState, useEffect, useCallback }  from 'react';
import { app } from '../config/app.js';
import {  getData,getHeaders, deleteDocElement } from '../controller/firestore.js';

import {  getPermission } from '../controller/user.js';
import {  ConfirmDialog } from '../components/Confirm.js';
import {  DynamicComponents } from '../components/DynamicComponents.js';
import {  DynamicActions } from '../components/DynamicActions.js';
import {  CustomTabPanel, a11yProps } from '../components/CustomTabPanel.js';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { DataGrid, itIT , GridToolbar, GridToolbarContainer, GridToolbarExport  } from '@mui/x-data-grid';
import { Link, Navigate, useLocation, withRouter } from 'react-router-dom';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { createTheme,ThemeProvider  } from '@mui/material/styles';
import { itIT as pickersitIT } from '@mui/x-date-pickers/locales';
import { itIT as coreiIT } from '@mui/material/locale';

import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Unstable_Grid2';
import { Alert, TextField, Typography } from '@mui/material';
import { FilterRecord } from '../components/FilterRecord.js';
import { applyTrasformation } from '../controller/record.js';
const theme = createTheme(
  app.theme,
  itIT, // x-data-grid translations
  pickersitIT, // x-date-pickers translations
  coreiIT, // core translations
);
function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport  csvOptions={{
    fileName: "export",
    delimiter: ';',
    utf8WithBom: true,
  }}/>
    </GridToolbarContainer>
  );
}



export default function ViewRecord(props) {
  const user=props.user;
  const { history } = props;
  const globalFilters=props.filters;
  const setGlobalFilters=props.setFilters;
  /*
  viewAction={
    "candidati": {
      "callbackTarget":"guide/nuovaGuida",
      "dataType":"singleChoice",
      "callbackData":null, copmilato a valle  
      "status":"requested",
    }
  }



  */
  
  const mapPageToNextCursor = React.useRef({});
  const collectionName=props.collectionName;
  
  const [tableData, setTableData] = useState({body:[]});
  const location = useLocation();
  const currentPath = location.pathname;
  const httpdata = location.state && location.state.data;
  const currentAction = httpdata && httpdata.viewAction;
  const componentParams = props.params;
  const viewName=httpdata && httpdata.viewConfig ? httpdata.viewConfig:props.view;
  const callbackViewActionUrl=httpdata && httpdata.callbackViewActionUrl;
  const [isLoading,setIsLoading] = useState(false);
  const [dataViewToRender,setDataViewToRender] = useState(false);
  let tempFilters={};
  const [filters, setFilters] = useState(tempFilters);
  
  const [lastQuery, setlastQuery] = useState({});
  const [rowsLength,setRowsLength]=useState(0);
  const [orderBy,setOrderBy]=useState(app.collections_config[collectionName].orderBy);
  let isLoadingTable={};
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: app.defaultQueryLimit,
  });
  const handleChangeTabState = (event, newValue) => {
    //const tabMap=["data","filter"];
    const tabMap=[0,1];
    setTabState(tabMap[newValue]);
  };
  const [tabState, setTabState] = React.useState(0);
  let viewConfig=app.collections_config[collectionName].views[viewName];
  
  
  const [errorMessage,setErrorMessage] =useState("");
  const activePermission=getPermission("collection",collectionName,null,user);
 // if (viewConfig.debug)
   // console.log("Active permission",activePermission);
  const addLink="/"+collectionName+"/update";
  const handlePaginationModelChange = (newPaginationModel) => {
    // We have the cursor, we can allow the page transition.
    if (
      newPaginationModel.page === 0 ||
      mapPageToNextCursor.current[newPaginationModel.page - 1]
    ) {
      setPaginationModel(newPaginationModel);
    }
  };
  const onEdit = React.useCallback((event,id) => {
    
    return false;
  }, []);
  
  const onView = React.useCallback((event,id) => {
    
    return false;
  }, []);
  const [openDelDialog,setOpenDelDialog]=useState(false);
  const [currentIdAction,setCurrentIdAction]=useState(null);
  const onDelete = React.useCallback((event,id) => {
      console.log("on delete ",id);
      setCurrentIdAction(id);
      setOpenDelDialog(true);
  }, []);
  const [needReload,setNeedReload]=useState(0);
  const delMessage='Confermi di voler cancellare questo '+app.collections_config[collectionName].singleLabel.toLowerCase()+'? L\'operazione non è reversibile.';
  const delButtons=[
    {
      name:"delete-"+collectionName+"-ok",
      text:"Ok",
      callback: async function () {
        if (viewConfig.debug) console.log("Confirm cancel",currentIdAction);
        setOpenDelDialog(false);
        await deleteDocElement(collectionName,currentIdAction);
        
        setNeedReload(needReload+1);
        if (viewConfig.debug) console.log("Setto need reload",needReload);
      }
    },
    {
      name:"delete-"+collectionName+"-ko",
      text:"Annulla",
      callback: function () {
        console.log("Ignored Confirm cancel",currentIdAction);
        setOpenDelDialog(false);
      }
    }

  ];
  const [headers, setHeaders] = useState(getHeaders(collectionName,viewConfig,{"permission":activePermission,"user":user,"viewAction":currentAction,"componentParams":componentParams},{"onView":onView,"onEdit":onEdit,"onDelete":onDelete}));
  
  useEffect(() => {
    if (globalFilters[collectionName]==null) return;
    setFilters(globalFilters[collectionName]);
  }, [globalFilters]);

  
  useEffect(() => {
    if (viewConfig.debug) console.log("Dentro view use effect");
    const fetchData = async () => {
      
      const currentPage=paginationModel.page;
      const pageSize=paginationModel.pageSize;
      
      const cursor = currentPage === 0 ? null : mapPageToNextCursor.current[currentPage-1];
      //if (tableData.docs && tableData.docs.length<pageSize) return;
      const params={
        "orderBy":orderBy,
    //    "pageSize":pageSize,
    //    "page":currentPage,
    //    "startAfter":cursor,
        "permission":activePermission,
        "filters":filters,
        "user":user,
        "viewAction":currentAction,
        "componentParams":componentParams,
      };
      viewConfig=app.collections_config[collectionName].views[viewName];
      const h=getHeaders(collectionName,viewConfig,{"permission":activePermission,"user":user,"viewAction":currentAction,"componentParams":componentParams},{"onView":onView,"onEdit":onEdit,"onDelete":onDelete});
      if (viewConfig.debug) console.log("Ricarcati headers "+collectionName,h);
      setHeaders(h);
      setlastQuery(params);
      
      const table=await getData(collectionName,viewConfig,params);
      setErrorMessage(table.error);
      //mapPageToNextCursor.current[currentPage] = (table.docs.length > 0 ? table.docs[table.docs.length-1] : null);
      mapPageToNextCursor.current[currentPage] = (table.docs.length > 0 ? table.docs[table.docs.length-1] : null);
      if (viewConfig.debug)
        console.log("Set table data", tableData);
      if (table.error=="") setTabState(0);
      setTableData( table);
      setRowsLength(table.rowsLength);
      
      isLoadingTable[collectionName]=false;
      
      setDataViewToRender(true);
      setIsLoading(false);
   };
    if (viewConfig.filter!==true) setTabState(0);
    if (isLoadingTable[collectionName]) return;
    //console.log("Use effect view table filters",filters);
    if (viewConfig.debug) console.log("Use effect "+collectionName+" Verifico filtri da applicare:",filters);
    if (viewConfig.debug) console.log("Auto load",viewConfig.autoLoad);
    if (viewConfig.autoLoad===false && (filters==null || Object.keys(filters).length===0)) {
      setTableData({body:[]});
      setDataViewToRender(false);
      return;
    }
    
    setDataViewToRender(true);
    setIsLoading(true);
    isLoadingTable[collectionName]=true;
    fetchData();
  }, [needReload,collectionName,viewName,filters]);
  //const actionRedirectRequested=null;
  
  const [actionRedirectRequested,setActionRedirectRequested] =useState(false);
  const [selectedData,setSelectedData] =useState(null);
  const handleRowClick = (params) => {
    if (currentAction && currentAction === "singleChoice") {
      
      console.log('Record selezionato:', params.row);
    
      setSelectedData(params.row);
      setActionRedirectRequested(true);
      
    }
  };
  const onFilterChange = React.useCallback((filtersReceived) => {
      let newFilters=[];
      
      Object.keys(filtersReceived).forEach(key => {
      
        if (filtersReceived[key].value!="") {
          
          newFilters[key]=filtersReceived[key];
        }
      });
      setTabState(0);
      setFilters(newFilters);
      setGlobalFilters( {...globalFilters, [collectionName]:newFilters});
      console.log("Filter change",newFilters);
  }, []);
  const keyDialog="delItem_"+collectionName;
  const dynContent=(viewConfig.customContent==null?null:viewConfig.customContent);
  const actionsOption= [];
  if (activePermission.can_add && true && !currentAction) actionsOption.push( {
    "key":"add_item",
    "text":<Link 
      to={ addLink }  
      state= {{ data: {callerUrl:currentPath }}} >Aggiungi {app.collections_config[collectionName].singleLabel}</Link>,
  });
  
  if (!activePermission.can_view)
    return <div>Autorizzazioni insufficienti</div>;
  return (
     
  <div align="" style={{ height: 600, width: '100%' }}>
    {
      
        currentAction && actionRedirectRequested &&
        <Navigate to={callbackViewActionUrl} state= {{ data: {selectedData:selectedData }}}/>  
      }
      {errorMessage!=="" && <Alert severity="error">{errorMessage}</Alert> }
    {isLoading? (<CircularProgress  size={50} variant="indeterminate" /> ):(
    <>

    {<DynamicComponents object={dynContent} property="pre_render_table_before_title"/>}

  
     
    
  <Grid container  sx={{pb:0}} columns={ 5 }>  
    {viewConfig.showTitle!==false &&
    <Grid xs={5} md={4} ><Typography sx={{pb:0}} variant="h4" gutterBottom>
    {currentAction && currentAction === "singleChoice"
                    ? `Seleziona un ${app.collections_config[collectionName].singleLabel.toLowerCase()}`
                    : currentAction && currentAction === "multiplaChoice"
                    ? `Seleziona uno o più ${app.collections_config[collectionName].label.toLowerCase()}`
                    : app.collections_config[collectionName].label}
      </Typography></Grid> }
      {(activePermission.can_add && false) && <Grid >
      <Link to={ addLink }  state= {{ data: {callerUrl:currentPath }}} > 
        <Fab variant="extended" color="primary" aria-label="add">
          <AddIcon /> Aggiungi {app.collections_config[collectionName].singleLabel}
        </Fab> 
      </Link>
    </Grid> }
    {actionsOption.length>0 && <Grid><DynamicActions options={actionsOption} text="Azioni"/></Grid>}
    
  </Grid>
    {<DynamicComponents object={dynContent} property="pre_render_table_after_title"/>}
    
    <Box sx={{ width: '100%' }}>
     {viewConfig.filter===true && <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabState} onChange={handleChangeTabState} aria-label="basic tabs example">
          <Tab label="Dati" {...a11yProps(0)} />
          <Tab label="Filtro" {...a11yProps(1)}/>
          
        </Tabs>
      </Box>}
      <CustomTabPanel value={tabState} index={0}>
         {dataViewToRender ?
          <DataGrid
              rows={ tableData.body}
              columns={headers}
              autoHeight
              initialState={viewConfig.initialState}
              rowCount={rowsLength}
          /*   pageSize={paginationModel.pageSize}*/
              pageSizeOptions={app.pageSizeOptions}
        //   page={paginationModel.page}
        //   onPaginationModelChange={handlePaginationModelChange}
        //   paginationModel={paginationModel}
        //   paginationMode="server"
            slots={{
              toolbar: CustomToolbar,
            }}
            isLoading={isLoading}
            onRowClick={handleRowClick}
            /*checkboxSelection*/
          /> : <Typography sx={{pt:2}} gutterBottom>E' obbligatorio impostare almeno un filtro</Typography>}
        {<DynamicComponents object={dynContent} property="after_render_table"/>}
          {true &&
         <ConfirmDialog 
         key={keyDialog} 
         title='Attenzione' 
         message={delMessage} 
         buttons={delButtons} 
         onClose={delButtons[1].callback} 
         open={openDelDialog} 
         setOpen={setOpenDelDialog} 
         /> }
      </CustomTabPanel>
      <CustomTabPanel value={tabState} index={1}>
        <FilterRecord collectionName={collectionName} viewName={viewName} onFilterChange={onFilterChange} filters={filters} />  
    
      </CustomTabPanel>
    </Box>
      
      
    </>
    )}
    
    </div>
      
      );
}
